<template>
	<div class="pcdetails">
		<el-backtop></el-backtop>
		<div class="pchome-headereli">
			<headers @ChangeEmit="ChangeEmit" ref="head"></headers>
		</div>
		<div class="productcjy" :class="productcjy_nav?'productcjy_nav':''">
			<div class="productc-leftjy">
				{{info.user}}
			</div>
			<div class="productc-rightjy">
				<div class="right-detailjy"  :style="acindex==1?'color:'+$store.state.themeColor:''" @click="aciscoll(1)">
					{{info.all}}
				</div>
				<div class="right-parameterjy" :style="acindex==2?'color:'+$store.state.themeColor:''" @click="aciscoll(2)">
					{{info.society}}
				</div>
				<div class="right-instructionsjy" :style="acindex==3?'color:'+$store.state.themeColor:''" @click="aciscoll(3)">
					{{info.campus}}
				</div>
				<div class="right-maintainjy" :style="acindex==4?'color:'+$store.state.themeColor:''" @click="aciscoll(4)">
					<div class="maintain-contjy">
						{{info.excel}}
						<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesdownup.svg" />
					</div>
				</div>
			</div>
		</div>
<!--		<div style="padding:10px 0;opacity:0" v-if="productcjy_nav">-->
<!--			<div class="productc-left">-->
<!--				{{vidcenter}}-->
<!--			</div>-->
<!--		</div>-->
		<div class="pcho-queryjy">
			<div class="pcho-queryheajy">{{info.title}}</div>
		</div>
		<div class="linesd"></div>
		<div class="elitesposition">
			<div class="position-left">
				<div class="posileft-hea">{{info.hot}}</div>
				<div class="posileft-foo">
					<div class="posileftfoo-item" :style="leftindex==0?'color:'+$store.state.themeColor:''" @click="leftnavi(0)">
						{{info.all}}
					</div>
					<div class="posileftfoo-item" v-for="(item,index) in channeljob" @click="leftnavi(item.id)" :key='index' :style="leftindex==item.id?'color:'+$store.state.themeColor:''">
						{{item.name}}
					</div>
				</div>
			</div>
			<div class="position-rightcc" id="position-rightcc">
				<el-table ref="jobTable" :data="hannel" :empty-text="$store.state.lang == 'en'?'No Date':'暂无数据'">
					<el-table-column
					  :label="info.name"
					  prop="name">
					</el-table-column>
					<el-table-column
					  :label="info.type"
					  prop="class_id_text">
					</el-table-column>
					<el-table-column
					  :label="info.salary"
					  prop="mark">
					</el-table-column>
					<el-table-column
					  :label="info.time"
					  prop="time">
					</el-table-column>
					<el-table-column class="xiangq"
					  :label="info.detail"
					  >
						<template slot-scope="scope">
							<div @click="toogleExpand(scope.row)" class="job-detail">
								{{info.open}}
								<i class="el-icon-arrow-right" :class=" scope.row.arrow ? 'arrow-more' : ''"></i>
							</div>
						</template>
					</el-table-column>
				    <el-table-column type="expand" width="1">
				      <template slot-scope="props">
				        <div class="content" v-html="props.row.content">
				          <!-- <div class="tab-cont">
				           {{ props.row.cn_content}}
				          </div> -->
				        </div>
				      </template>
				    </el-table-column>
				  </el-table>
			</div>
		</div>
		<div class="recrprocess" v-if="campus==1">
			<div class="recprocess-hea">{{info.process}}</div>
			<div class="recprocess-imga">
				<div class="imga-begl">
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesresum.svg" />
					{{info.delivery}}
				</div>
				<div class="elimga-minl">
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesnext.svg" />
				</div>
				<div class="imga-begl">
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/eliteslecture.svg" />
					{{info.propaganda}}
				</div>
				<div class="elimga-minl">
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesnext.svg" />
				</div>
				<div class="imga-begl">
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesinter.svg" />
					{{info.interview}}
				</div>
				<div class="elimga-minl">
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesnext.svg" />
				</div>
				<div class="imga-begl">
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesemplo.svg" />
					{{info.examination}}
				</div>
				<div class="elimga-minl">
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesnext.svg" />
				</div>
				<div class="imga-begl">
					<img src="https://api.glzmn.com/uploads/icon-file/emplo.svg" />
					{{info.employment}}
				</div>
			</div>

			<div class="recprocess-faq">
				<div class="faqhaeda">{{info.faq}}</div>
				<div class="faq-item" v-for="(item,index) in elitefaq">
					<div class="faqitem-hea">{{item.name}}</div>
					<div class="faqitem-foo" v-html="item.content"></div>
				</div>
			</div>
		</div>
		<div class="woodpecker-p">
			<div class="wood-hea">{{info.userIn}}</div>
			<div class="wood-foo">
				<div class="woodfoo-item" @click="navtofilwork(1)">
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesf4.png" />
					<div class="woodfooitem-title">{{info.around}}</div>
				</div>
				<div class="woodfoo-item" @click="navtofilwork(2)">
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesf2.png" />
					<div class="woodfooitem-title">{{info.happy}}</div>
				</div>
				<div class="woodfoo-item" @click="navtofilwork(3)">
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesf1.png" />
					<div class="woodfooitem-title">{{info.welfare}}</div>
				</div>
				<div class="woodfoo-item" @click="navtofilwork(4)">
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesf3.png" />
					<div class="woodfooitem-title">{{info.train}}</div>
				</div>
			</div>
		</div>
    <footers ref=is_change></footers>
	</div>
</template>

<script>
	import '@/lib-flexible/flexible.js'
	import {session} from '../../storage/storage.js';
	import headers from '../../common/header.vue'
	import footers from '../../common/footers.vue'
	export default{
		data(){
			return{
				productcjy_nav:false,
				id:'',
                oldScrollTop: 0,
				leftindex:0,
				navheader:true,
				heshow:false,
				show: false,
				playli:true,
				playri:true,
				acindex:1,
				producheanon:true,
				campus:1,
				channeljob:'',
				hannel:[],
				elitefaq:'',
				queryxsla:'',
				info:{
					user : "诚聘精英",
					all : "全部",
					society: "社会招聘",
					campus: "校园招聘",
					excel: "应聘登记表下载",
					title: "啄尔不凡  属你非凡",
					hot:"热门招聘职位",
					name: "职位名称",
					type: "职位类别",
					salary:"薪资待遇",
					time:"发布时间",
					detail:"详情介绍",
					open:"展开详情",
					process:'招聘流程',
					faq:"FAQ",
					delivery:"投递简历",
					propaganda:"宣传会",
					interview:"面试",
					examination:"体检",
					employment:"录用",
					around:"工作环境",
					happy:"快乐生活",
					welfare:"薪资福利",
					train:"培训发展",
					userIn:'人在啄木鸟',
				},
				value: '',
				valuelang: '',
				platese:0,
				scroll_height:0,
				nav_color:session.get('channel_id')==1?'#e62129':session.get('channel_id')==2?'#1a4698':'#5f5d5d'
			}
		},
		created() {
			this.acindex = this.$route.query.e ? this.$route.query.e : 1
			this.platese = this.acindex
			this.getParams()
			this.pcchanneljobtype()
			this.pcchanneljoblis()
			this.pcget_faq()
			this.getqueryxsls()
			this.heshow=true
		},
		components:{
			headers,
			footers
		},
		watch:{
		'$route': 'getParams'
		},
		mounted() {
			
            // window.addEventListener("scroll", this.scrolling)
			document.addEventListener('scroll',this.handleScroll,false)
			this.scroll_height = document.documentElement.scrollTop

			this.$once('hook:beforeDestroy', () => {
				document.removeEventListener('scroll', this.handleScroll,false)
			})
			
			if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {

				this.$router.push({path:'./phelites',query:{e:this.$route.query.e}})
			}

			sessionStorage.setItem('page',JSON.stringify({name:'pcelites',data:false}))
		},
		methods: {
			toogleExpand(row) {
				row.arrow = row.arrow ? false : true
				this.$refs.jobTable.toggleRowExpansion(row)
			},
			navtofilwork(e){
				this.$router.push({path: '/pcfilework',query:{e}})
			},
			scrolling() {
			                // 滚动条距文档顶部的距离
			                let scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
			                    document.body.scrollTop
			                // 滚动条滚动的距离
			                let scrollStep = scrollTop - this.oldScrollTop;
			                // 更新——滚动前，滚动条距文档顶部的距离
			                this.oldScrollTop = scrollTop;
							// console.log(scrollTop)
			                if (scrollStep < 0) {
			                    this.producheanon=false
			                } else {
			                    this.producheanon=true
			                }
			            },
			getqueryxsls(){
				let data= {
					mold: "pc",
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
				};
				this.$api.get_channel_index(data).then((res) => {
					this.queryxsla = res.data.recruit_file;
				});
			},
			/* getIndexData() {
			  this.$api.pcindex({ mold: "pc",lang:session.get("lang") == '' ? 'cn' : session.get("lang") }).then((res) => {
			    this.queryxsla = res;
				console.log('000',this.queryxsla)
			    
			
			  });
			}, */
      ChangeEmit(){ //子组件传递
        //主动调用子组件
        this.$refs.is_change.get_index_channel_data();
        this.$refs.is_change.pageParam();
        this.getParam();
        this.leftnavi(this.leftindex);
        this.pcchanneljobtype();
		this.getqueryxsls()
        this.pcget_faq();
      },
      getParam(){
        let lang =  session.get("lang");
        if (lang === "cn"){
          this.info = {
                user : "诚聘精英",
                all : "全部",
                society: "社会招聘",
                campus: "校园招聘",
                excel: "应聘登记表下载",
                title: "啄尔不凡  属你非凡",
                hot:"热门招聘职位",
                name: "职位名称",
                type: "职位类别",
                salary:"薪资待遇",
                time:"发布时间",
                detail:"详情介绍",
                open:"展开详情",
                process:'招聘流程',
                faq:"FAQ",
                delivery:"投递简历",
                propaganda:"宣传会",
                interview:"面试",
			    examination:"体检",
			    employment:"录用",
                around:"工作环境",
                happy:"快乐生活",
                welfare:"薪资福利",
                train:"培训发展",
                userIn:'人在啄木鸟',
          }
        }else{
          this.info = {
            user : "JOIN US",
            all : "All",
            society: "General Recruitment",
            campus: "Campus Recruitment",
            excel: "Registration Form Download",
            title: "Hero Meets Hero.",
            hot:"Hot Jobs",
            name: "Job Title",
            type: "Job Category",
            salary:"Salary",
            time:"Release Time",
            detail:"Details",
            open:"Deployment details",
            process:'Recruitment Process',
            faq:"FAQ",
            delivery:"CV Delivery",
            propaganda:"Career Talk",
            interview:"Interview",
            employment:"Offer",
            around:"Work environment",
            happy:"Wonderful life",
            welfare:"C&B package",
            train:"Training and development",
            userIn:'In Woodpecker',
          }
        }
      },
			leftnavi(e){
				this.leftindex=e
				this.pcchanneljoblis()
			},
			pcchanneljobtype(){
				let data={
						lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
						channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
						page:1,
						pageSize:100,
						
					}
				this.$api.get_channel_job_type(data).then((res) => {
						this.channeljob=res.data
						  
				});
			},
			pcchanneljoblis(){
				
				let data={
						type_id:this.leftindex,
						plate:this.platese,
						lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
						channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
						page:1,
						pageSize:100,
						
					}
				this.$api.get_channel_job_list(data).then((res) => {
						this.hannel=res.data
						/* this.channeljoblist=res.data */
						  
				});
			},
			pcget_faq(){
				let data={
						lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
						channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
						page:1,
						pageSize:100,
						
					}
				this.$api.get_faq(data).then((res) => {
						this.elitefaq=res.data
						
						  
				});
			},
			aciscoll(e){
				
				this.acindex=e
				if(e==4){
					/* console.log('000',this.queryxsla) */
					var name = '意向岗位-学校-专业-学历-姓名-啄木鸟医疗应聘登记表';
					    var url = this.queryxsla;
					    var suffix = url.substring(url.lastIndexOf("."), url.length);
					      //跳过浏览直接下载
					    fetch(url)
					        .then(res => res.blob())
					        .then(blob => {
					        const a = document.createElement("a");
					        const objectUrl = window.URL.createObjectURL(blob);
					        a.download = name;
					        a.href = objectUrl;
					        a.click();
					        window.revokeObjectURL(objectUrl);
					    })
					/* document.getElementById("inscte").scrollIntoView(); */
				}else if(e==2){
					this.platese=2
					this.pcchanneljoblis()
					this.campus=2
					/* document.getElementById("paradme").scrollIntoView(); */
				}else if(e==3){
					this.platese=1
					this.pcchanneljoblis()
				}else if(e==1){
					this.platese=0
					this.pcchanneljoblis()
				}
				
			},
			handleScroll () {
			    let scrollTop = document.documentElement.scrollTop ||document.body.scrollTop 
				let head_height = this.$refs.head.getHeaderHeight()
				if(scrollTop>head_height){
					this.productcjy_nav = true
					this.scroll_height = scrollTop
				}else{
					this.productcjy_nav = false
				}
				this.$refs.head.scrollTop_change(scrollTop,'pcelites')
			},
			nextimg(){
				let l = this.list_img.length;
				let scroll = document.getElementById('scroll-x');
				let diatance = scroll.scrollWidth - scroll.clientWidth;
				if(this.current_index == 0){
					this.current_index = l-1;
					scroll.scrollLeft = diatance;
				}else{
					this.current_index--;
					scroll.scrollLeft -= diatance / (l - 1);
				}
			},
			preimg(){
				let l = this.list_img.length;
				let scroll = document.getElementById('scroll-x');
				let diatance = scroll.scrollWidth - scroll.clientWidth;
				if(this.current_index+1 == l){
					this.current_index = 0;
					scroll.scrollLeft = 0;
				}else{
					this.current_index++;
					scroll.scrollLeft += diatance / (l - 1);
				}
			}, 
			enter(index){
			  this.navheader= true;
			},
			playenterli(){
				this.playli=false
			},
			
			playenterri(){
				this.playri=false
			},
			playleaveli(){
				this.playli=true
			},
			playleaveri(){
				this.playri=true
			},
		  getParams () {
				this.id = this.$route.query.e
			  this.acindex = this.$route.query.e ? this.$route.query.e : 1
			  this.aciscoll(this.acindex)
		  }
		  
		 }
	}
</script>

<style >
	body{
		margin: 0;
		padding: 0;
		background: #fff;
	}
	.pcdetails{
		position: relative;
		background: #fff;
	}
	.pchome-headereli{
		width: 100vw;
		position: relative;
		background-size: 100% 100%;
		padding-top: 79px;
		box-sizing: border-box;
	}
	
	.bb{
		background: #FAFAFA;
		position: fixed;
		top: 0; 
		z-index: 99;
	}
	.aboutitem-hea{
		margin-top: 80px;
		margin-bottom: 40px;
		height: 33px;
		font-size: 24px;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 33px;
		letter-spacing: 1px;
	}
	.aboutitem-fooitem{
		margin-bottom: 10px;
	}
	.fooitem-left{
		width: 110px;
		height: 32px;
		border-radius: 4px;
		border: 1px solid #EAEAEA;
		display: flex;
		align-items: center;
		justify-content: center;
		
		
		font-size: 16px;
		font-weight: 400;
		color: #FAFAFA;
		margin-right: 20px;
	}
	.fooitem-left img{
		width: 16px;
		height: 16px;
		margin-right: 6px;
	}
	.aboutitem-foosus{
		display: flex;
		margin-bottom: 20px;
	}
	.fooitem-right{
		font-size: 16px;
		font-weight: 400;
		color: #CCCCCC;
	}
	.fooitem-cont{
		margin-top: 25px;
		margin-left: 40px;
	}
	.fooitem-cont:first-child{
		margin-left: 0px;
	}
	.fooite-img{
		display: flex;
	}
	.fooite-img img{
		width: 90px;
		height: 90px;
	}
	.fooite-nam{
		text-align: center;
		margin-top: 20px;
	}
	.right-tit{
		margin-bottom: 5px;
	}
	.homefoot{
		
		height: 94px;
		background: #272727;
		border-top: 2px solid #666;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.foot-hea{
		height: 22px;
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		line-height: 22px;
	}
	.foot-f{
		height: 22px;
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		line-height: 22px;
		margin-top: 10px;
		margin-bottom: 20px;
	}
	.productcjy{
		width: 1400px;
		/* height: 80px; */
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 260px;
	}
	.productc-leftjy{
		font-size: 28px;
		font-weight: 500;
		color: #5d5f5f;
	}
	.productc-rightjy{
		font-size: 16px;
		font-weight: 400;
		color: #5d5f5f;
		display: flex;
		align-items: center;
	}
	.right-detailjy{
		margin-right: 24px;
		cursor: pointer;
	}
	.right-parameterjy{
		margin-right: 24px;
		cursor: pointer;
	}
	.right-instructionsjy{
		margin-right: 24px;
		cursor: pointer;
	}
	.right-maintainjy{
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px;
		border: 1px solid #666666;
		padding: 8px 16px;
	}
	.maintain-contjy{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.maintain-contjy img{
		width: 20px;
		height: 20px;
		margin-left: 8px;
	}
	.linesd{
		width: 100%;
		height: 1px;
		background: #EAEAEA;
	}
	.pcho-queryjy{
		width: 100%;
		height: 400px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		background: url(https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesbanner.png) no-repeat;
		background-size: 100% 100%;
	}
	.pcho-queryheajy{
		height: 56px;
		font-size: 60px;
		font-weight: 600;
		color: #fff;
		line-height: 56px;
		letter-spacing: 2px;
	}
	
	
	.cc{
		color: #D03E3D;
	}
	.elitesposition{
		width: 1400px;
		padding: 60px 260px;
		display: flex;
	}
	.posileft-hea{
		font-size: 24px;
		font-weight: 500;
		color: #5d5f5f;
		margin-bottom: 32px;
	}
	.posileft-foo{
		font-size: 18px;
		font-weight: 400;
		color: #5d5f5f;
	}
	.posileftfoo-item{
		margin-bottom: 24px;
		cursor: pointer;
	}
	.position-left{
		border-right: 1px solid #EAEAEA;
		width: 240px;
	} 
	.recrprocess{
		width: 1400px;
		padding: 60px 260px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		background: #FAFAFA;
	}
	.recprocess-hea{
		font-size: 40px;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 2px;
	}
	.recprocess-imga{
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 107px;
	}
	.imga-begl{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		font-size: 32px;
		font-weight: 400;
		color: #5d5f5f;
		letter-spacing: 1px;
		margin-right: 88px;
	}
	.imga-begl:last-child{
		margin-right: 0px;
	}
	.imga-begl img{
		width: 140px;
		height: 140px;
		margin-bottom: 30px;
		
	}
	.elimga-minl{
		width: 45px;
		height: 27px;
		margin-top: -60px;
		margin-right: 88px;
		display: flex;
	}
	.elimga-minl:last-child{
		margin-right: 88px;
		display: flex;
	}
	.elimga-minl img{
		width: 100%;
		height: 100%;
		display: flex;
	}
	.recprocess-faq{
		width: 1400px;
		background-color: #fff;
		display: flex;
		
		flex-direction: column;
		padding: 60px 40px;
		box-sizing: border-box;
		margin-top: 60px;
	}
	.faqhaeda{
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 40px;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 2px;
		margin-bottom: 54px;
	}
	.faq-item{
		margin-bottom: 30px;
	}
	.faqitem-hea{
		font-size: 24px;
		font-weight: 600;
		color: #5d5f5f;
		margin-bottom: 18px;
	}
	.faqitem-foo{
		font-size: 18px;
		font-weight: 500;
		color: #666666;
		white-space: pre-wrap;
	}
	.woodpecker-p{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.wood-hea{
		
		font-size: 40px;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 2px;
		margin-top: 60px;
	}
	.wood-foo{
		width: 1400px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
		margin-top: 73px;
	}
	.woodfoo-item{
		width: 680px;
		height: 320px;
		margin-bottom: 40px;
		position: relative;
		-webkit-border-radius:22px;
		-ms-border-radius:22px;
		-o-border-radius:22px;
		-moz-border-radius:22px;
		overflow: hidden;
		transform: rotate(0deg);
		
	}
	
	.woodfoo-item:nth-child(2n){
		margin-left: 40px;
	}
	.woodfoo-item img{
		width: 680px;
		height: 320px;
		transition: all .75s linear;
	}
	.woodfoo-item:hover img{
		cursor: pointer;
		width: 680px;
		height: 320px;
		transform: scale(1.02,1.02); 
		
	}
	.woodfooitem-title{
		position: absolute;
		top: 0px;
		left: 0px;
		/* top: 132px;
		left: 256px; */
		width: 680px;
		height: 320px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 40px;
		font-weight: 600;
		color: #FFFFFF;
		letter-spacing: 2px;
		cursor: pointer;
	}
	.demo-table-expand {
	  font-size: 0;
	}
	.demo-table-expand label {
	  width: 90px;
	  color: #99a9bf;
	}
	.demo-table-expand .el-form-item {
	  margin-right: 0;
	  margin-bottom: 0;
	  width: 50%;
	}
	.position-rightcc{
		width: 1160px;
		margin-left: 79px;
	}
	
	.tab-cont{
		background-color: #EAEAEA;
		padding: 30px;
	}
	.el-table__expanded-cell[class*=cell]{
		padding: 0px 0px;
		padding-bottom: 30px;
	}
	.el-table--enable-row-hover .el-table__body tr:hover>td{
		background-color: #fff;
	}
	/*.el-table__row td:nth-child(6n) .cell{*/
	/*	width: 25px;*/
	/*	height: 25px;*/
	/*	!* text-align: center;*/
	/*	display: flex;*/
	/*	align-items: center;*/
	/*	justify-content: center; *!*/
	/*	!* background-color: #00FF00; *!*/
	/*}*/
	/*.el-table__row td:nth-child(6n) .el-icon-arrow-right:before{*/
	/*	content: url(https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcelitesimg/elitesdown.png);*/
	/*}*/
	/*.el-table__row td:nth-child(6n) .el-icon-arrow-right{*/
	/*	!* text-align: center; *!*/
	/*}*/
	/*.el-table__row td:nth-child(6n) .el-table__expand-icon{*/
	/*	!* width: 25px;*/
	/*	height: 25px;*/
	/*	text-align: center;*/
	/*	*/
	/*	display: flex;*/
	/*	align-items: center;*/
	/*	justify-content: center; *!*/
	/*}*/
	/*.el-table__row td:nth-child(6n) .el-table__expand-icon>.el-icon{*/
	/*	!* position: relative;*/
	/*	left: -4px;*/
	/*	top: 9px; *!*/
	/*}*/
	/*.el-table__row td:nth-child(6n) .el-table__expand-icon--expanded{*/
	/*	!* transform: rotate(180deg); *!*/
	/*}*/
	.elitesposition .content {
		padding: 10px;
	}
	.elitesposition .content p , .elitesposition .content div , .elitesposition .content span {
		font-size: 18px!important;
		color: #5d5f5f!important;
	}
	.el-table thead{
		font-size: 21px;
		font-weight: 500;
		color: #5d5f5f;
	}
	.el-table__row {
		height: auto!important;
		font-size: 18px;
		color: #5d5f5f;
	}
	.el-table .el-table__cell {
		padding: 20px 0;
	}
	.el-table__row .el-table__cell .cell{
		overflow: visible!important;
		line-height:1.4!important;
	}
	/* tr th:nth-child(6n){
		background-color: #00FF00;
	} */
	tr th:nth-child(5n).is-leaf{
		/*height: 71px;*/
		/*position: absolute;*/
		/*right: 30px;*/
		/*width: 250px;*/
		/*padding-bottom: 35px;*/
		/*text-align: right;*/
		/*line-height: 71px;*/
		/*z-index: 5;*/
	}
	.xiangq{

	}
	
	
	.el-table__row td:nth-child(5n){
		/* height: 71px; */
		/* width: 210px;
		position: absolute;
		right: 60px;
		border-bottom: #EBEEF5 1px solid;
		z-index: 999;
		text-align: right;
		padding-right: 0px; */
	}
	.el-table__row td:nth-child(5n) .cell{
		/*text-align: right;*/
		/* position: absolute;
		top: 20px;
		right: 4px; */
	}
	.el-table tr{
		height: 71px;
	}
	.el-table td, .el-table th{
		padding: 0 0;
	}
	/* .header-nav{
		width: 1400px;
		height: 79px;
		display: flex;
		align-items: center;
		padding: 0 260px;
		position: fixed;
		top: 0; 
	} */
	.nav-wit{
		
	}
	.nav-left{
		width: 100px;
		height: 50px;
	}
	.nav-left img{
		width: 100%;
		height: 100%;
	}
	/* .nav-center-item:hover{
		border-bottom: 2px solid #E31E24;
	} */
	
	.nav-center-item:first-child{
		margin-left: 0;
	}
	.nav-right{
		display: flex;
		align-items: center;
		color: #fff;
		font-size: 16px;
		font-weight: 400;
		margin-left: 180px;
	}
	.nav-right .search{
		display: flex;
		align-items: center;
		width: 20px;
		height: 20px;
		margin-right: 20px;
		cursor: pointer;
	}
	.nav-right .search img{
		width: 100%;
		height: 100%;
	}
	.nav-right .homename{
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 20px;
		cursor: pointer;
	}
	.nav-right .homename img{
		width: 16px;
		height: 16px;
		margin-left: 4px;
	}
	.nav-right .language{
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
	.nav-right .language img{
		width: 16px;
		height: 16px;
		margin-left: 6px;
	}
	.producflex{
		position: fixed;
		z-index: 9;
		background-color: #fff;
	}
	.productcjy_nav{
		top: 0;
		position: fixed;
		z-index: 9;
		background-color: #fff;
		background: rgba(255,255,255,.72);
    	backdrop-filter: saturate(180%) blur(20px);
	}
	thead .cell {
		padding: 10px 0;
	}
	.el-icon-arrow-right {
		transition: all .3s linear 0s;
	}
	.arrow-more {
		transform: rotate(90deg);
	}
	.job-detail {
		cursor: pointer;
	}
	.el-table_1_column_6 {
		display: none;
	}
</style>
